module.exports = __webpack_public_path__ + "static/media/dovesdogs.02bebf00.ico";